import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import {TABLET_BREAKPOINT} from '../utils/constants';
import {TESTS} from '../utils/abacus';
import DynamicSeoLinkpile from '../components/common/seo-linkpile/DynamicSeoLinkpile';
import {fullExposures, withErrorBoundary} from './helpers';

export const fullExposureTests = [
    TESTS.SEARCH_FORM_SLP,
    TESTS.SLP_TRAFFIC_TEST_AA,
    TESTS.VRBO_WEB_GLOBAL_MESSAGING_BANNER,
    TESTS.DISCOVERY_SITE_NAVIGATION,
    TESTS.DISCOVERY_SITE_NAVIGATION_NEW_LABEL,
];

export function TemplateComponent(props) {
    const {isMobile, hasTouch, dispatch} = props;

    useEffect(() => {
        dispatch({
            type: 'SET_VIEWPORT',
            payload: {isMobile, hasTouch},
        });
    }, [dispatch, isMobile, hasTouch]);

    return (
        <>
            {fullExposures([...fullExposureTests])}
            <main className="app-main" />
            {withErrorBoundary(<DynamicSeoLinkpile forceExpanded />)}
        </>
    );
}

export const Template = connect()(
    determineIfMobile(TemplateComponent, TABLET_BREAKPOINT)
);

Template.displayName = 'Template';

export default Template;
